import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { CgMenuLeft } from 'react-icons/cg';
import { useOutletContext, useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Notification from '../../../components/Notification';
import PermissionWrapper from '../../../components/PermissionWrapper';
import { AppMainModules, TripPermission, TripSubModules } from '../../../utils/app-constant';
import { plusIcon } from '../../../utils/svgs';

const TripsListHeader = ({ onOpenCreateTrip, onToggleMobileSidebar }) => {
    const navigate = useNavigate();
    const outletContext = useOutletContext();
    const handleMenuClick = onToggleMobileSidebar || outletContext?.toggleMobileSidebar;

    const handleCreateClick = () => {
        if (onOpenCreateTrip) {
            onOpenCreateTrip();
        } else {
            navigate("/trips?create=true");
        }
    };

    return (
        <>
            {/* Desktop Header (Exact same as Trips.jsx) */}
            <div className="desktop_header_only">
                <Breadcrumbs values={["Trip Management"]} />

                <div className='access_view'>
                    <h2>Trip Management</h2>

                    <div className='services_buttons'>
                        <Notification />

                        <PermissionWrapper
                            permission={TripPermission.Create}
                            module={TripSubModules.TripsList}
                            mainModule={AppMainModules.tripManagement}
                        >
                            <button onClick={handleCreateClick}>
                                {plusIcon} Create New Trip
                            </button>
                        </PermissionWrapper>
                    </div>
                </div>
            </div>

            {/* Mobile Header (Figma Exact Mobile Header) */}
            <div className='mobile_header_only mobile_figma_header_section'>
                <div className='mobile_header_left_controls'>
                    <button
                        className='mobile_menu_icon_btn'
                        onClick={handleMenuClick}
                        title="Open Main Sidebar"
                    >
                        <CgMenuLeft style={{ fontSize: '24px', color: '#1c1c1c' }} />
                    </button>
                    <h2 className='mobile_header_title'>Trip List Management</h2>
                </div>

                <div className='mobile_header_right_controls'>
                    <PermissionWrapper
                        permission={TripPermission.Create}
                        module={TripSubModules.TripsList}
                        mainModule={AppMainModules.tripManagement}
                    >
                        <button
                            className='btn_figma_primary'
                            onClick={handleCreateClick}
                        >
                            <FiPlus style={{ fontSize: '13px' }} /> Create Trip
                        </button>
                    </PermissionWrapper>
                </div>
            </div>
        </>
    );
};

export default TripsListHeader;
